<template lang="pug">
.v-video.video
	.video__iframe-wrap(v-if="type === 'youtube' && youtubeSrc")
		iframe.video__iframe(ref="ytvideo"
				:src="youtubeSrc"
				title="YouTube video player"
				frameborder="0"
				allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
				referrerpolicy="strict-origin-when-cross-origin"
				allowfullscreen)
	video.video__video(v-else-if="src"
			ref="video"
			:controls="controls"
			:poster="poster"
			:loop="loop"
			:muted="muted"
			:autoplay="autoplay"
			:playsinline="playsinline")
		source.video__source(:src="src" :type="computedType")
	template(v-else-if="data && data.src")
		.video__video-wrapper
			v-svg-icon.video__btn-icon.video__btn-icon--play(v-if="!isPlay"
				icon="video-play"
				@click="playVideo")
			v-svg-icon.video__btn-icon.video__btn-icon--pause(v-if="isPlay"
				icon="video-pause"
				@click="stopVideo")
			img.video__poster(v-if="!isPlay && isFirstPlay"
					:src="data.poster"
					alt=""
					loading="lazy")
			video.video__video(v-if="!isFirstPlay"
					ref="video"
					:controls="data.controls"
					:poster="data.poster"
					:loop="data.loop"
					:muted="data.muted"
					:autoplay="data.autoplay"
					:playsinline="data.playsinline")
				source.video__source(:src="data.src" :type="computedType")
</template>

<script>
import sourceMixin from '../../components/mixins/v-mixin-source.vue';

export default {
	mixins: [
		sourceMixin,
	],

	props: {
		type: {
			type: String,
			default: 'video/mp4'
		},

		poster: {
			type: String,
			default: null
		},

		src: {
			type: String,
			default: null,
			required: true
		},

		autoplay: {
			type: Boolean,
			default: false
		},

		controls: {
			type: Boolean,
			default: true
		},

		playsinline: {
			type: Boolean,
			default: false
		},

		loop: {
			type: Boolean,
			default: false
		},

		origin: {
			type: String,
			default: null
		},

		muted: {
			type: Boolean,
			default: false
		}
	},

	data() {
		return {
			isStarted: false,
			youtubeSrc: null,
			isPlay: false,
			isFirstPlay: true,
			data: null
		};
	},

	created() {
		this.initVideo();
		this.startVideo()
	},

	methods: {
		dataSet(data) {
			this.data = data;
		},

		initVideo() {
			if (this.type === 'youtube') {
				const url = new URL(this.src);

				let {pathname} = url;

				if(pathname && pathname.indexOf("/embed") === -1) {
					url.pathname = `/embed${pathname}`;
				}

				url.searchParams.set('autoplay', this.autoplay ? '1' : '0');
				url.searchParams.set('mute', this.muted ? '1' : '0');
				url.searchParams.set('loop', this.loop ? '1' : '0');
				if (this.origin) {
					url.searchParams.set('origin', 'https://yourdomain.by');
				}
				url.searchParams.set('playsinline', '1');
				this.youtubeSrc = url.href;

			}
		},

		startVideo() {
			this.isStarted = true;
			this.$nextTick(() => {
				if (this.type === 'youtube') {
					const url = new URL(this.youtubeSrc);
					url.searchParams.set('autoplay', '1');
					url.searchParams.set('loop', '1');
					url.searchParams.set('showinfo', '0');
					url.searchParams.set('rel', '0');
					url.searchParams.set('modestbranding', '1');
					url.searchParams.set('controls', '0');
					this.youtubeSrc = url.href;
				} else if (!this.data) {
					this.$refs['video']?.play();
				}
			})

		},

		stopVideo() {
			this.isPlay = false;
			this.$refs['video'].pause();
		},

		playVideo() {
			this.isPlay = true;
			this.isFirstPlay = false;
			this.$refs['video'].play();
		},
	},

	computed: {
		computedType() {
			if(this.type === 'video' && this.src) {
				return `${this.type}/${this.src.substring(this.src.indexOf('.') + 1)}`
			}
		}
	}
};
</script>